import Vue from "vue";
import Vuex from "vuex";
import getNested from "lodash-es/get";

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getTonnageZones({ dispatch }) {
      let response = await dispatch("apiRequest", {
        method: "get",
        apiUrl: "/entities/zones",
        data: {}
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response.data;
    },

    async getTonnageZonesWithPolygons({ dispatch }) {
      let response = await dispatch("apiRequest", {
        method: "get",
        apiUrl: "/tonnage/zone/listwithpolygons",
        data: {}
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response.data;
    },

    async getTonnageBalanceZonesStats({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/zone",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response;
    },

    async getTonnageFleetSpeed({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/speed",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response;
    },

    async getTonnageBalanceBasinStats({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/basin",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }
      return response;
    },

    async getTonnageZonesGlobalStat({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/zone/global",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return getNested(response, "data.globalTonnageZoneCounts", []);
    },

    async getTonnageFleetStatus({ dispatch }, parameters) {
      // expected parameters:
      // format, group, metric, range, segment, subSegment
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/fleet/status",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response;
    },

    async getTonnageFleetDevelopment({ dispatch }, parameters) {
      // expected parameters:
      // format, group, metric, range, segment, subSegment
      let response = await dispatch("apiRequest", {
        method: "post",
        apiUrl: "/tonnage/fleet/development ",
        data: parameters
      });

      if (response.error) {
        console.log("api error", response);
        return null;
      }

      return response;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        "api/apiRequest",
        { ...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2 },
        { root: true }
      );
    }
  }
};
